import { render, staticRenderFns } from "./SetBuyout.vue?vue&type=template&id=231322c4&"
import script from "./SetBuyout.vue?vue&type=script&lang=js&"
export * from "./SetBuyout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports